import { cloneElement } from 'react'
import {
  CreateButton,
  Datagrid,
  Filter,
  List,
  SearchInput,
  TextField,
  TopToolbar,
  useListContext,
  useRecordContext,
} from 'react-admin'

import Pill from '../components/pill'

const moment = require('moment')

const AssuranceListFilter = (props) => (
  <Filter {...props}>
    <SearchInput source="copro_code" />
  </Filter>
)

const ToolbarAssurance = (props) => {
  const { filters } = props
  const { resource, displayedFilters, filterValues, showFilter } =
    useListContext()

  return (
    <TopToolbar>
      {filters &&
        cloneElement(filters, {
          resource,
          showFilter,
          displayedFilters,
          filterValues,
          context: 'button',
        })}
      <CreateButton
        color="secondary"
        variant="contained"
        resource="contracts"
        basePath="contracts"
      />
    </TopToolbar>
  )
}

const ExpirationDatePillWrapper = () => {
  const { id, expiration_date } = useRecordContext()
  let status = 'error'
  const internal_expiration_date = moment(expiration_date)
  if (internal_expiration_date.isSameOrAfter(moment())) status = 'success'
  if (
    internal_expiration_date.isBetween(moment().subtract(3, 'month'), moment())
  )
    status = 'secondary'

  return (
    <Pill
      id={id}
      value={internal_expiration_date.format('D/M/Y')}
      status={status}
    />
  )
}

const CustomUrlArrayField = ({ source, download }) => {
  const record = useRecordContext()
  if (!record) return null

  return (
    record[source] &&
    record[source].split(';').map((url) => (
      <>
        <a href={url} download={download}>
          {url}
        </a>
        <br />
      </>
    ))
  )
}

export const AssuranceList = (props) => (
  <List
    {...props}
    exporter={false}
    hasCreate={false}
    perPage={100}
    actions={<ToolbarAssurance />}
    filters={<AssuranceListFilter />}
  >
    <Datagrid bulkActionButtons={false}>
      <TextField source="copro_code" />
      <CustomUrlArrayField download={true} source="url" />
      <ExpirationDatePillWrapper source="expiration_date" />
    </Datagrid>
  </List>
)
